export const pricingPlans = {
  free: {
    key: 'free',
    label: 'billz_IN!',
    description: 'Do 3 faktur miesięcznie',
    price: '0',
    subPrice: '00',
    productId: null,
    productCode: '',
  },
  minimum: {
    key: 'minimum',
    label: 'billz_UP!',
    description: 'Do 10 faktur miesięcznie',
    price: '24',
    subPrice: '99',
    productId: null,
    productCode: '',
  },
  standard: {
    key: 'standard',
    label: 'billz_GO!',
    description: 'Bez limitu faktur',
    price: '29',
    subPrice: '99',
    productId: null,
    productCode: '',
  },
  advanced: {
    key: 'advanced',
    label: 'billz_FLY!',
    description: 'Bez limitu faktur',
    price: '49',
    subPrice: '99',
    productId: null,
    productCode: '',
  },
};

export const pricingItems = [
  {
    title: 'faktury wystawione w m-cu',
    help: '',
    free: '3',
    freeMobile: '3',
    minimum: '10',
    minimumMobile: '10',
    standard: 'dowolna',
    standardMobile: 'dowolna',
    advanced: 'dowolna',
    advancedMobile: 'dowolna',
  },
  {
    title: 'liczba użytkowników',
    help: '',
    free: '1',
    freeMobile: '1',
    minimum: '1',
    minimumMobile: '1',
    standard: '3',
    standardMobile: '3',
    advanced: '10',
    advancedMobile: '10',
  },
  {
    title: 'dostęp księgowego',
    help: '',
    free: false,
    freeMobile: false,
    minimum: true,
    minimumMobile: true,
    standard: true,
    standardMobile: true,
    advanced: true,
    advancedMobile: true,
  },
  {
    title: 'wsparcie opiekuna',
    help: '',
    free: false,
    freeMobile: false,
    minimum: false,
    minimumMobile: false,
    standard: true,
    standardMobile: true,
    advanced: true,
    advancedMobile: true,
  },
  {
    title: 'przechowywanie faktur kosztowych',
    help: '',
    free: false,
    freeMobile: false,
    minimum: false,
    minimumMobile: false,
    standard: true,
    standardMobile: true,
    advanced: true,
    advancedMobile: true,
  },
  {
    title: 'automatyczne, cykliczne faktury',
    help: '',
    free: false,
    freeMobile: false,
    minimum: false,
    minimumMobile: false,
    standard: true,
    standardMobile: true,
    advanced: true,
    advancedMobile: true,
  },
  {
    title: 'dostęp do API',
    help: '',
    free: false,
    freeMobile: false,
    minimum: false,
    minimumMobile: false,
    standard: true,
    standardMobile: true,
    advanced: true,
    advancedMobile: true,
  },
  {
    title: 'automatyczna windykacja',
    help: '',
    free: false,
    freeMobile: false,
    minimum: false,
    minimumMobile: false,
    standard: false,
    standardMobile: false,
    advanced: true,
    advancedMobile: true,
  },
];
